import { Paper } from "@mantine/core";
import { bankAccountApi } from "apis/bankAccountApi";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { BankAccountResponseType } from "constants/types/bankAccount";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/BankAccount/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import BankAccountFormFields from "../BankAccountFormFields/BankAccountFormFields";
import { editValidationSchema } from "./config";

interface EditFormProps {
  bankAccount: BankAccountResponseType;
  onClose?: () => void;
  mutate?: () => void;
}

const EditForm: FC<EditFormProps> = ({ bankAccount, onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      bankName: bankAccount.bankName,
      accountNumber: bankAccount.accountNumber,
      accountHolder: bankAccount.accountHolder,
      isActive: bankAccount.isActive,
    },
    validationSchema: editValidationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const res = await bankAccountApi.update(bankAccount.id, values);
        if (res.data.success) {
          notification.success({ title: "Cập nhật tài khoản ngân hàng thành công" });
          onClose?.();
          mutate?.();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({
          title: "Cập nhật tài khoản ngân hàng thất bại",
          message: error?.error?.message,
        });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={FORM_IDS.EDIT} onSubmit={formik.handleSubmit}>
          <BankAccountFormFields formik={formik} />
        </form>
      </Paper>
    </Loading>
  );
};

export default EditForm;
